module.exports = __webpack_public_path__ + "static/media/DSC01494.13bd9f36.jpg";